import { IFile } from 'interfaces';

type ImageArrayItem = IFile['file']['originFileObj'];

export const getImagesObject = (
  imagesArray: ImageArrayItem[],
  isEditingPhysicalNft: boolean
): Record<string, ImageArrayItem> => {
  let newFileIndex = 0;
  return imagesArray.reduce((acc, cur) => {
    let newKey: string | number = 0;
    if (cur instanceof File) {
      newKey = `new_${newFileIndex}`;
      newFileIndex++;
    } else {
      newKey = cur.uid;
    }
    const key = isEditingPhysicalNft
      ? `images[${newKey}]`
      : `product[images][${newKey}]`;
    acc[key] = cur;
    return acc;
  }, {} as Record<string, ImageArrayItem>);
};
